import { z } from 'zod';
import { idShapes } from './ids.js';
export const localTurnShape = (turnDataShape = z.any()) => z.object({
    playerId: idShapes.User,
    data: turnDataShape,
});
export const turnShape = (turnDataShape = z.any()) => localTurnShape(turnDataShape).extend({
    createdAt: z.string(),
    roundIndex: z.number(),
});
/**
 * Gets the start and end of the round for a given day.
 * Start is inclusive, end is exclusive.
 */
export function getRoundTimerange(day, timezone) {
    const today = new Date(day.getFullYear(), day.getMonth(), day.getDate(), day.getHours(), day.getMinutes());
    const tomorrow = new Date(day.getFullYear(), day.getMonth(), day.getDate(), day.getHours(), day.getMinutes() + 1);
    const roundStart = new Date(today.toLocaleString('en-US', {
        timeZone: timezone,
    }));
    const roundEnd = new Date(tomorrow.toLocaleString('en-US', {
        timeZone: timezone,
    }));
    return {
        roundStart,
        roundEnd,
    };
}
export const gameRoundShape = z.object({
    turns: z.array(z.any()),
    roundIndex: z.number(),
});
export const gameRoundSummaryShape = z.custom((v) => z
    .object({
    turns: z.array(z.object({
        playerId: idShapes.User,
        data: z.unknown().nullable(),
    })),
    yourTurnData: z.unknown().nullable(),
    initialPlayerState: z.unknown(),
    roundIndex: z.number(),
})
    .parse(v));
export function groupTurnsToRounds(turns) {
    return turns.reduce((acc, turn) => {
        const round = acc[turn.roundIndex] ?? {
            roundIndex: turn.roundIndex,
            turns: [],
        };
        round.roundIndex = turn.roundIndex;
        round.turns.push(turn);
        acc[turn.roundIndex] = round;
        return acc;
    }, []);
}
//# sourceMappingURL=rounds.js.map